module.exports = __webpack_public_path__ + "static/media/YM41_2.0c27e3d3.jpg";